var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spinner spinner--stretch", style: _vm.styles },
    [
      _c("div", { staticClass: "rect rect-1", style: _vm.rectStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "rect rect-2", style: _vm.rectStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "rect rect-3", style: _vm.rectStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "rect rect-4", style: _vm.rectStyles }),
      _vm._v(" "),
      _c("div", { staticClass: "rect rect-5", style: _vm.rectStyles })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ae3dd4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ae3dd4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Stretch.vue
// module id = qbuJ
// module chunks = 0